module.exports = __webpack_public_path__ + "media/packs/images/flags/PT-a371ae7a3219dc05b934cf3daecbb682.png";